import { LOGOUT } from '../../app/authState'
import { apiErrorCodes } from '../../utils/constants'
import { errorCodes, getUserFriendlyErrorMessage } from '../../utils/errormessages'
import {
  GET_INTAKE_FORMS_COLLECTION,
  GET_INTAKE_FORMS_COLLECTION_SUCCESS,
  GET_INTAKE_FORMS_COLLECTION_ERROR,
  GET_INTAKE_FORM_BY_ID_SUCCESS,
  GET_INTAKE_FORM_BY_ID_ERROR,
  CREATE_NEW_INTAKE_FORM_SUCCESS,
  CREATE_NEW_INTAKE_FORM_ERROR,
  SAVE_INTAKE_FORM_SUCCESS,
  SAVE_INTAKE_FORM_ERROR,
  SET_IS_INTAKE_FORM_WAS_CREATED,
  SET_INTAKE_FORM_DATA,
  SET_INTAKE_FORM_ERROR,
  INTAKE_FORM,
} from './IntakeFormsConstants'

const initialState = {
  loading: false,
  error: '',
  intakeFormsList: [],
  isIntakeFormWasCreated: false,
  intakeFormData: {},
}

export default function intakeFormsReducer(state = initialState, action = {}) {
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  switch (action.type) {
    case GET_INTAKE_FORMS_COLLECTION:
      return {
        ...state,
        loading: true,
      }
    case SET_INTAKE_FORM_ERROR:
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      if (action.extraData.intakeFormId) {
        const cloneData = JSON.parse(JSON.stringify(state.intakeFormData))
        // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
        if (cloneData[`${action.extraData.intakeFormId}`]) {
          // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
          cloneData[`${action.extraData.intakeFormId}`] = {
            // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
            ...cloneData[`${action.extraData.intakeFormId}`],
          }
        }
        return {
          ...state,
          // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
          intakeFormData: { ...cloneData },
        }
      }
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        error: action.payload,
      }
    case SET_IS_INTAKE_FORM_WAS_CREATED:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        isIntakeFormWasCreated: action.payload,
      }
    case SET_INTAKE_FORM_DATA: {
      const cloneData = JSON.parse(JSON.stringify(state.intakeFormData))
      // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
      cloneData[`${action.payload.intakeFormId}`] = { ...action.payload.data, loading: false, error: '' }
      return {
        ...state,
        // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
        intakeFormData: { ...cloneData },
      }
    }
    case SAVE_INTAKE_FORM_SUCCESS: {
      const cloneData = JSON.parse(JSON.stringify(state.intakeFormData))
      // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
      cloneData[`${action.extraData.intakeFormId}`] = { ...action.payload }
      return {
        ...state,
        // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
        intakeFormData: { ...cloneData },
      }
    }
    case GET_INTAKE_FORMS_COLLECTION_SUCCESS:
      return {
        ...state,
        loading: false,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        intakeFormsList: action.payload.IntakeForms,
      }
    case GET_INTAKE_FORM_BY_ID_SUCCESS: {
      const cloneData = JSON.parse(JSON.stringify(state.intakeFormData))
      // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
      cloneData[`${action.payload.IntakeFormId}`] = { ...action.payload }
      return {
        ...state,
        // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
        intakeFormData: { ...cloneData },
      }
    }
    case CREATE_NEW_INTAKE_FORM_SUCCESS:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        intakeFormsList: [...state.intakeFormsList, action.payload],
        isIntakeFormWasCreated: true,
      }
    case GET_INTAKE_FORMS_COLLECTION_ERROR:
    case GET_INTAKE_FORM_BY_ID_ERROR:
    case SAVE_INTAKE_FORM_ERROR:
    case CREATE_NEW_INTAKE_FORM_ERROR: {
      let message = ''
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      if (action.payload.UserFriendlyErrorCode || action.payload.UserFriendlyErrorCode === '') {
        message =
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          action.payload.UserFriendlyErrorCode ?
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            getUserFriendlyErrorMessage(action.payload.UserFriendlyErrorCode, null, action.payload.extra)
          : ''
      } else {
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        switch (action.payload.ErrorCode) {
          case 'NameNotUnique':
            message = getUserFriendlyErrorMessage(errorCodes.NAME_ALREADY_EXISTS, null, 'Intake form')
            break
          case apiErrorCodes.INTAKE_FORM_NOT_FOUND:
            message = getUserFriendlyErrorMessage(errorCodes.DOES_NOT_EXIST_NO_REFRESH, null, INTAKE_FORM)
            break
          default:
            message = getUserFriendlyErrorMessage(errorCodes.DEFAULT)
            break
        }
      }
      const cloneData = JSON.parse(JSON.stringify(state.intakeFormData))
      // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
      if (cloneData[`${action?.extraData?.intakeFormId}`]) {
        // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
        cloneData[`${action.extraData.intakeFormId}`] = {
          // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
          ...cloneData[`${action.extraData.intakeFormId}`],
          loading: false,
          error: message,
        }

        return {
          ...state,
          // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
          intakeFormData: { ...cloneData },
        }
      }
      return {
        ...state,
        error: message,
        loading: false,
      }
    }
    case LOGOUT:
      return { ...initialState }
    default:
      return state
  }
}
